/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Col_DocumentInputs */

const cs_signing_col_document = /** @type {(inputs: Signing_Col_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument`)
};

const en_signing_col_document = /** @type {(inputs: Signing_Col_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Signing_Col_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_col_document = /** @type {((inputs?: Signing_Col_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Col_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_col_document(inputs)
	return cs_signing_col_document(inputs)
});